module.exports = __webpack_public_path__ + "static/img/userLogo.07f5480e.png";